import { render, staticRenderFns } from "./tabFixtureEvents.vue?vue&type=template&id=68fb7c64&"
import script from "./tabFixtureEvents.vue?vue&type=script&lang=js&"
export * from "./tabFixtureEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports